<!-- notes: https://svelte.dev/examples/modal -->

<script lang="ts">
  export let show: boolean;
  export let backdropStyle: "normal" | "white" = "normal";

  let dialog: HTMLDialogElement | null = null;

  let dialogSupported = typeof HTMLDialogElement === "function";

  $: if (dialog && show) dialog.showModal();

  $: if (dialog && !show) dialog.close();
</script>

{#if dialogSupported}
  <dialog bind:this={dialog} class={`backdrop-${backdropStyle}`}>
    <slot />
  </dialog>
{/if}

<style>
  dialog {
    overflow: hidden;
    max-width: 32em;
    border-radius: 0.2em;
    border: none;
    padding: 0;
    background-color: transparent;
    justify-content: center;
    align-items: center;
  }

  dialog[open] {
    display: flex;
  }

  dialog:focus {
    outline: none;
  }

  dialog::backdrop {
    backdrop-filter: blur(10px);
  }

  dialog.backdrop-normal::backdrop {
    background: rgba(0, 0, 0, 0.5);
  }

  dialog.backdrop-white::backdrop {
    background: rgba(255, 255, 255, 0.8);
  }

  dialog[open]::backdrop {
    animation: fade 0.2s ease-out;
  }

  @keyframes fade {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
